var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.764071 16.9168C0.342086 16.9168 0 16.5747 0 16.1528C0 15.7308 0.342086 15.3887 0.76407 15.3887H0.964134C1.49661 15.3887 1.92827 14.957 1.92827 14.4246V7.78568C1.92827 6.41539 2.37102 5.2038 3.25653 4.15091C4.00761 3.25768 4.93961 2.63755 6.05253 2.29053C6.40581 2.18037 6.66667 1.86589 6.66667 1.49583C6.66667 1.14209 6.79618 0.841338 7.0552 0.593568C7.31422 0.345968 7.62871 0.222168 7.99867 0.222168C8.3688 0.222168 8.68373 0.345968 8.94347 0.593568C9.20338 0.841338 9.33333 1.14209 9.33333 1.49583C9.33333 1.86589 9.59419 2.18037 9.94747 2.29053C11.0604 2.63755 11.9924 3.25768 12.7435 4.15091C13.629 5.2038 14.0717 6.41539 14.0717 7.78568V14.4245C14.0717 14.957 14.5034 15.3887 15.0359 15.3887H15.2359C15.6579 15.3887 16 15.7308 16 16.1528C16 16.5747 15.6579 16.9168 15.2359 16.9168H0.764071ZM7.99813 19.7777C7.46747 19.7777 7.01378 19.5974 6.63707 19.2367C6.5213 19.1259 6.42332 19.0082 6.34311 18.8837C6.0441 18.4193 6.51945 17.9358 7.07173 17.9358H8.92827C9.48055 17.9358 9.9563 18.4195 9.65717 18.8837C9.57654 19.0089 9.47793 19.1269 9.36133 19.2379C8.98338 19.5978 8.52898 19.7777 7.99813 19.7777Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell_icon.e33134ba8c721b3f492c743faed29408.svg";
export { ForwardRef as ReactComponent };